import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalState } from "../../interfaces/connected-components/modal";
import { ModalType } from "../../shared/utils/enums";

const initialState: ModalState = {
  isVisible: false,
  type: ModalType.INFO,
  title: '',
  message: '',
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<Omit<ModalState, 'isVisible'>>) => {
      return {
        ...state,
        ...action.payload,
        isVisible: true,
      };
    },
    hideModal: (state) => {
      if (state.onClose) state.onClose();
      state.isVisible = false;
    },
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer; 